import styled from 'styled-components';
import type { PolymorphicComponentProps } from '../../utils/types';
import type { ButtonProps } from './button';
import { ButtonHost } from './button';

export const IconButtonHost = styled(ButtonHost)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  border-color: transparent;
`;

export const IconButton = <C extends React.ElementType = 'button'>(
  props: PolymorphicComponentProps<C, ButtonProps>
) => {
  const { as, children, fullWidth, ...rest } = props;
  return (
    <IconButtonHost as={as as any} $fullWidth={fullWidth} {...rest}>
      {children}
    </IconButtonHost>
  );
};
